export const MAIL = "mail";
export const PHONE = "phone";
export const FOLDER = "folder";



// WEBPACK FOOTER //
// ./src/views/Dashboardlive/SelectList/ModalChoice.js